<script lang="ts" setup>
import { type PropType } from 'vue';
import { FormElement, useFormElement } from '@common';

const props = defineProps({
  element: {
    type: Object as PropType<FormElement>,
    required: true
  }
});

const { value } = useFormElement(props.element);
</script>

<template>
  <h3 class="text-warning font-weight-bold d-flex ga-1">
    <span class="font-weight-light text-black">{{ $t('subscription.header.extendModal.label.yearlypriceText') }}</span>
    <span>{{ value }} Ft + ÁFA </span>
  </h3>
</template>
